<template>
  <div class="field-wrapper">
    <div v-for="chip in displayedChips" :key="chip.id" class="field-chips">
      <v-chip
        class="ma-0"
        :close="!disabled"
        :small="small"
        @click:close="emit('remove:chip', chip)"
      >
        <span class="truncate">
          {{ startCase(chip.title || '') }}
        </span>
      </v-chip>
    </div>
    <vs-text v-if="numberOverflowChips > 0"> ...{{ numberOverflowChips }} more selected </vs-text>
    <slot />
  </div>
</template>

<script setup lang="ts">
import VsText from '@/components/vision/VsText.vue'
import { startCase } from 'lodash'
import { computed } from 'vue'

type ChipType = {
  id: number | string | null
  title: string | null
}
const props = defineProps<{
  chips: ChipType[]
  maximumChips?: number
  disabled?: boolean
  small?: boolean
}>()

const emit = defineEmits<{ (event: 'remove:chip', value: ChipType): void }>()

const displayedChips = computed(() => {
  return props.chips.slice(0, props.maximumChips).map((c) => ({
    id: c.id,
    title: c.title || '',
  }))
})

const numberOverflowChips = computed(() => {
  if (props.maximumChips) {
    return props.chips.length - props.maximumChips
  }
  return 0
})
</script>

<style scoped>
.field-wrapper {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: var(--space-smaller) var(--space-small);
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
}

.field-chips {
  flex: 0;
  padding: var(--space-smaller);
  max-width: 100%;
}

.field-chips ~ input {
  width: auto;
  flex-basis: 100px;
}

.truncate {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}
</style>
